<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row>
					<div class="flex-bw">
						<el-form :inline="true" :model="searchCondition">
							<!-- <el-form-item label="模糊搜索">
								<el-input
									v-model="searchCondition.keyword"
									placeholder="请输入关键词"
									clearable
									@keyup.enter.native="searchButton"
								></el-input>
							</el-form-item> -->
							<ScreeCompany
								ref="ScreeCompany"
								:allowField="allowField"
								@ScreeCompany="ScreeCompany"
							/>
							<el-form-item label="报送时间">
								<el-date-picker
									:picker-options="pickerOptions"
									format="yyyy 年 MM 月"
									value-format="yyyy-MM-dd"
									v-model="searchCondition.month"
									type="monthrange"
									placeholder="选择月份段"
									clearable
									range-separator="至"
									start-placeholder="开始月份"
									end-placeholder="结束月份"
								></el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchButton" style="color: #1890ff"
									>查询</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-row>
				<el-row class="export-box">
					<div class="flex-bw">
						<div class="btn-box"></div>
						<div>
							<el-select
								v-model="value"
								placeholder="请选择导出类型"
								@change="selectData"
								class="select-box"
								size="medium"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
							<el-button
								:loading="downloadLoading"
								style="margin: 0 0 20px 20px"
								type="primary"
								size="medium"
								icon="el-icon-document"
								@click="handleDownload"
							>
								导出
							</el-button>
						</div>
					</div>
				</el-row>

				<ApeTable
					ref="apeTable"
					:data="companyList"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import { mapGetters, mapState } from "vuex";
import ScreeCompany from "@/components/ScreeCompany.vue";
import moment from "moment";

export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		ScreeCompany,
	},
	data() {
		return {
			// 允许显示的字段
			allowField: ["settlementId"],
			exportColumns:[
				{
					title: "序号",
					value: "id",
				},
				{
					title: "是否已取得登记证照",
					value: "is_djzz",
				},
				{
					title: "名称（已取得登记证照）",
					value: "qddjzz.xm",
				},
				{
					title: "统一社会信用代码（纳税人识别号）（已取得登记证照）",
					value: "qddjzz.dpidtyshxydm",
				},
				{
					title: "专业服务机构标识（已取得登记证照）",
					value: "qddjzz.zyfwjgbs",
				},
				{
					title: "姓名（未取得登记证照）",
					value: "fullname",
				},
				{
					title: "证件类型（未取得登记证照）",
					value: "id_type",
				},
				{
					title: "证件号码（未取得登记证照）",
					value: "id_number",
				},
				{
					title: "国家或地区（未取得登记证照）",
					value: "gj",
				},
				{
					title: "是否存在免于报送收入信息情形（未取得登记证照）",
					value: "sfmybs",
				},
				{
					title: "免报类型（未取得登记证照）",
					value: "wqddjzz.mblx",
				},
				{
					title: "地址",
					value: "id_address",
				},
				{
					title: "店铺（用户）名称",
					value: "dpfullname",
				},
				{
					title: "店铺（用户）唯一标识码",
					value: "dpid",
				},
				{
					title: "网址链接（选填）",
					value: "url",
				},
				{
					title: "开户银行/非银行支付机构（结算（支付）账户信息（选填））",
					value: "jszhxx.khyh",
				},
				{
					title: "账户名称（结算（支付）账户信息（选填））",
					value: "jszhxx.zhmc",
				},
				{
					title: "银行账户/支付账号（结算（支付）账户信息（选填））",
					value: "jszhxx.yhzh",
				},
				{
					title: "联系人姓名",
					value: "lxfullname",
				},
				{
					title: "联系电话",
					value: "lxmobile",
				},
				{
					title: "经营开始时间",
					value: "jy_start_time",
				},
				{
					title: "经营结束时间",
					value: "jy_end_time",
				},
				{
					title: "信息状态标识",
					value: "xxztbs",
				},
			],
			columns: [
				// {
				// 	title: "序号",
				// 	value: "id",
				// },
				{
					title: "税源地名称",
					value: "channel_name",
				},
				{
					title: "姓名",
					value: "fullname",
				},
				{
					title: "证件类型",
					value: "id_type",
				},
				{
					title: "证件号码",
					value: "id_number",
				},
				{
					title: "国家或地区",
					value: "gj",
				},
				{
					title: "是否存在免于报送收入信息情形",
					value: "sfmybs",
				},
				{
					title: "地址",
					value: "id_address",
				},
				{
					title: "店铺(用户)名称",
					value: "dpfullname",
				},
				{
					title: "店铺(用户)唯一标识码",
					value: "dpid",
				},
				{
					title: "联系人姓名",
					value: "lxfullname",
				},
				{
					title: "联系电话",
					value: "lxmobile",
				},
				{
					title: "经营开始时间",
					value: "jy_start_time",
				},
				{
					title: "经营结束时间",
					value: "jy_end_time",
				},
				{
					title: "信息状态标识",
					value: "xxztbs",
				},
			],
			// 搜索条件
			searchCondition: {
				keyword: "",
				channel_account: "",
				month: [],
			},
			loadingStaus: true,
			// 表格列表数据
			companyList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: "total, sizes, prev, pager, next, jumper",
				total: 0,
			},
			// 分页的offset,序号列使用
			offset: 0,
			options: [
				{
					value: "xlsx",
					label: "xlsx",
				},
				{
					value: "csv",
					label: "csv",
				},
				{
					value: "txt",
					label: "txt",
				},
			],
			value: "xlsx",
			bookType: "xlsx", //导出表格类型
			downloadLoading: false,
		};
	},

	computed: {
		...mapGetters(["userPermissions", "buttonType"]),
		...mapState({
			userInfo: (state) => state.userInfo,
		}),
		pickerOptions() {
			const year = new Date().getFullYear();
			return {
				disabledDate: this.disabledDate,
				shortcuts: [
					{
						text: "第一季度",
						onClick: (picker) => {
							// 第一季度：1月1日 - 3月31日
							const start = new Date(year, 0, 1); // 1月1日
							const end = new Date(year, 2, 31); // 3月31日
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "第二季度",
						onClick: (picker) => {
							// 第二季度：4月1日 - 6月30日
							const start = new Date(year, 3, 1); // 4月1日
							const end = new Date(year, 5, 30); // 6月30日
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "第三季度",
						onClick: (picker) => {
							// 第三季度：7月1日 - 9月30日
							const start = new Date(year, 6, 1); // 7月1日
							const end = new Date(year, 8, 30); // 9月30日
							picker.$emit("pick", [start, end]);
						},
					},
				],
			};
		},
	},
	watch: {
		"$route.matched": function (n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
	},
	methods: {
		ScreeCompany(option, key) {
			console.log(option, key);
			if (key === "settlement") {
				this.searchCondition.channel_account = option;
			}
		},
		disabledDate(time) {
			return time.getTime() > Date.now();
		},

		//导出
		async handleDownload() {
			this.downloadLoading = true;
			let list = await this.init("export");
			if (!list || list.length === 0) {
				this.$message.warning("暂无数据可导出");
				this.downloadLoading = false;
				return;
			}
			import("@/excel/Export2Excel").then((excel) => {
				let sHeader = this.exportColumns.map((item) => item.title);
				const data = this.formatJson(list);
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `身份信息报送表${time}`;
				excel.export_json_to_excel({
					header: sHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.bookType, //Optional
				});
				this.downloadLoading = false;
			});
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let tempArr = [];
				this.exportColumns.map((item) => {
					tempArr.push(v[item.value] || "");
				});
				return tempArr;
			});
		},
		//选择导出类型
		selectData(e) {
			this.bookType = e;
		},

		// 搜索
		searchButton() {
			this.init("search");
		},

		// 切换页码操作
		async switchPaging() {
			this.init();
		},

		// 初始化列表
		async init(type) {
			let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
				current_page: 1,
				page_size: 10,
			};
			if (type == "export") {
				pagingInfo.page_size = 50000;
				console.log(pagingInfo, "页面对象");
			} else {
				this.loadingStaus = true;
			}
			if (type == "search") {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.handleSearchCondition();
			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.get_qxy_tax_identity_info_list(
				searchCondition
			);

			if (type == "export") {
				return data || [];
			} else {
				this.companyList = [];
				this.$nextTick(() => {
					this.companyList = data || [];
				});
				this.pagingData.total = pages?.total || 0;
				console.log(this.pagingData.total, "总数");
				this.offset = pages?.offset || 0;
				this.loadingStaus = false;
			}
		},
		// 处理搜索条件
		handleSearchCondition() {
			let searchCondition = {}
			if(this.searchCondition.month){
				searchCondition.start_time=this.searchCondition.month[0]+" 00:00:00"
				searchCondition.end_time=this.searchCondition.month[1]+" 23:59:59"
			}
			if(this.searchCondition.channel_account){
				searchCondition.channel_account=this.searchCondition.channel_account
			}
			return searchCondition;
		},

		keyupSubmit() {
			document.onkeydown = (e) => {
				console.log(e);
				let _key = window.event.keyCode;
				if (_key === 13) {
					this.searchButton();
				}
			};
		},
	},
	created() {
		this.keyupSubmit();
	},
	mounted() {
		// 默认选择上个月的第一天和最后一天
		const lastMonth = moment().subtract(1, "M");
		const startDate = lastMonth.startOf("month").format("YYYY-MM-DD");
		const endDate = lastMonth.endOf("month").format("YYYY-MM-DD");
		this.searchCondition.month = [startDate, endDate];
		this.init();
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
</style>

